var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dot-line"},[_c('div',{staticClass:"line"}),_c('div',{staticClass:"dot",class:{ active: _vm.isActive && (_vm.childLabel === 'Beef' || _vm.childLabel === 'Live Cattle'),
  active1: _vm.isActive && _vm.childLabel === 'Spot',
  active2: _vm.isActive && _vm.childLabel === 'Futures' }}),_c('div',{staticClass:"line",class:{ hide: _vm.isLast }})])}
var staticRenderFns = []

export { render, staticRenderFns }